import type { LabelKind, LabelPrintJob } from "../types";

/**
 * Trigger the browser's native print flow for label pages that already render
 * the label markup themselves. Kept as a thin wrapper so pages can swap
 * between browser and Zebra flows through the same interface.
 */
export function browserPrint(): void {
  if (typeof window !== "undefined") {
    window.print();
  }
}

/**
 * Some callers want a symmetric signature with `printJobs`. For browser
 * flows the ZPL is irrelevant — we just trigger `window.print()`.
 */
export function browserPrintJobs(_jobs: LabelPrintJob[] | LabelKind[] = []): void {
  browserPrint();
}
